module.exports = __webpack_public_path__ + "static/1186912068.d5d77756.jpg";